import * as React from "react";

import { PresentationFacet } from "../model";

import {
  usePlpPresenterForTheFilterMenu_Mobile,
  useProductListController_forFiltering,
  useProductListPresentationModelFacets,
} from "../providers";

import { replaceAll } from "../utils";

import { FilterSelectedOptions } from "./FilterSelectedOptions";

export const MainMenu: React.FunctionComponent = () => {
  const { presentationFacets } = useProductListPresentationModelFacets();
  const { getUncategorizedSelectedOptions } =
    useProductListController_forFiltering();

  const { handleNavigatingToAFilterSubMenu_onMobile } =
    usePlpPresenterForTheFilterMenu_Mobile();

  const filters = React.useMemo(() => {
    const presentationFacetsWithUncategorized = [
      ...[
        {
          uncategorized: true,
        },
      ],
      ...presentationFacets,
    ];
    return presentationFacetsWithUncategorized.map((facetOrSpecialCase) => {
      const facet = facetOrSpecialCase as PresentationFacet;
      const specialCase = facetOrSpecialCase as { uncategorized: boolean };
      const onActionFacet = () => {
        if (!specialCase.uncategorized && facet.hasSubMenu) {
          handleNavigatingToAFilterSubMenu_onMobile(facet as PresentationFacet);
        }
      };

      let uncategorizedSelectedOptions = [];
      if (specialCase.uncategorized) {
        uncategorizedSelectedOptions = getUncategorizedSelectedOptions();
      }

      if (
        specialCase.uncategorized &&
        uncategorizedSelectedOptions.length < 1
      ) {
        return null;
      }

      return (
        <div
          key={facet.key}
          className={`filter ${facet.hasSubMenu ? "with-sub-menu" : ""}`}
          onClick={onActionFacet}
        >
          <div className="content">
            {specialCase.uncategorized ? null : (
              <p>{replaceAll(facet.title, "_", " ")}</p>
            )}
            <FilterSelectedOptions
              facet={specialCase.uncategorized ? undefined : facet}
              uncategorized={specialCase.uncategorized}
            />
          </div>
        </div>
      );
    });
  }, [presentationFacets]);

  return <React.Fragment>{filters}</React.Fragment>;
};
